
const dataWork = [
    {
        id: 1,
        numb: '01',
        title: 'SmithyDao',
        text : "Immerse in a 2D isometric dark fantasy MMO, set in Smithonia. Unleash action-packed adventures, explore a realm of mystique, and forge your path.",
        img: 'bg-img-1',
        link: "/smithydao",
        active: true
    },
    {
        id: 2,
        numb: '02',
        title: 'Beratone',
        text : "A collaborative rhythmic farming game meticulously crafted for Berachain, offering players an engaging co-op experience within its blockchain ecosystem.",
        img: 'bg-img-2',
        link: "/beratone"
    },
    {
        id: 3,
        numb: '03',
        title: "Goldinc",
        text : "Engage in an immersive mobile MMO idle game. Cultivate your army, vie for resources, and engage in strategic battles within a dynamic virtual world.",
        link: "/goldinc"
    },
    {
        id: 4,
        numb: '04',
        title: "Smolage",
        text : 'A 2D pixel art game set in the Mesozoic Era, offering players a procedural survival experience amid prehistoric landscapes and challenges.',
        link: "/smolage"
    },
]
export default dataWork;